import React from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, MenuProps, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../../stores/auth.store';
import './ProfileDropdown.scss';
import { signInPath } from '../../../routes';

const { Text } = Typography;
const ProfileDropdown = ({ userName }: { userName: string }) => {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);

  const handleLogout = async () => {
    try {
      await logout();
      navigate(signInPath);
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <a href={'/'} onClick={handleLogout}>
          Cerrar Sesión
        </a>
      ),
    },
  ];

  return (
    <div className={'ProfileDropdown'}>
      <Dropdown menu={{ items }}>
        <a onClick={(e) => e.preventDefault()} href={'/'}>
          <Space>
            <Text className={"ProfileDropdown__text"}>{userName}</Text>
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
    </div>
  );
};

export default ProfileDropdown;
